import { render, staticRenderFns } from "./passengerData.vue?vue&type=template&id=265b0d07&scoped=true&"
import script from "./passengerData.vue?vue&type=script&lang=js&"
export * from "./passengerData.vue?vue&type=script&lang=js&"
import style0 from "./passengerData.vue?vue&type=style&index=0&id=265b0d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b0d07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VSimpleTable})
